import xhrService from "../xhrService";

type BillingApi = {
    getBillingDetails: () => Promise<any>;
    getInvoicePdf: (invoiceId: string) => Promise<any>;
};

export const BillingDetailsApi: BillingApi = {
    getBillingDetails: () => {
        return xhrService.get(`api/billingDetails`).then(response => response.data);
    },
    getInvoicePdf: (invoiceId) => {
        return xhrService.get(`api/billingDetails/invoice/${invoiceId}/download`, {
            responseType: 'blob'
        }).then(response => response.data);
    }
};